function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.625 23.25c0 4.012.457 11.75 4.469 11.75 2.36 0 5.407-2.696 7.531-5.719a5.995 5.995 0 001.219 3.344L14 42l1 13h2V42l.906-7.25a6.09 6.09 0 001.719.25c.118 0 .227-.025.344-.031l-.219 7.375L22 55h2l-1.25-12.938.219-8.093a5.997 5.997 0 002.187-2.625c.794.703 1.825 1.156 2.969 1.156 1.39 0 2.612-.635 3.438-1.625a8.783 8.783 0 001.53 1.594l1.938 7.875L36 54h2V40l-.938-5.781c1.323.238 3.298.434 5.438.562l2.875 7.344L49 55h2l-2.719-13.625-2-6.469c4.793.019 9.344-.498 9.344-2.218 0-1.798-6.85-8.41-10.469-10.376C42.272 20.747 38.687 20.21 36 21c-2.383.701-4.308 1.71-5.25 3.375-.74-.532-1.645-.875-2.625-.875a4.453 4.453 0 00-3.688 1.938A5.984 5.984 0 0019.625 23a5.95 5.95 0 00-3.563 1.188c.063-.331.094-.643.094-.938 0-4.012-3.856-7.254-7.281-7.25-3.418.004-7.875 3-7.25 7.25zM5.281 21c.92 0 2.344.906 2.344 2.563C7.625 25.218 6.202 27 5.281 27c-.92 0-1.656-1.343-1.656-3s.736-3 1.656-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-6 7c3-2 5.35-1.65 7 0 3 3 3 11 3 11h0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-8.865 10.37C-6.314 7.82-3.94 7.705-2 9c3.529 2.355 5.094 10.2 5.094 10.2h0"
}));

var SvgAnt = function SvgAnt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ant.02c5188d.svg";
export { ForwardRef as ReactComponent };